export const formFieldsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  overflowY: 'auto',
  height: '100%',
};

export const rowStyles = {
  display: 'flex',
  gap: '16px',
};
